var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41337 3.18065C4.64903 1.99993 6.29096 1.33886 8.00004 1.33398C11.6819 1.33398 14.6667 4.31875 14.6667 8.00065C14.6667 11.6825 11.6819 14.6673 8.00004 14.6673C4.31814 14.6673 1.33337 11.6825 1.33337 8.00065C1.33337 7.63246 1.63185 7.33398 2.00004 7.33398C2.36823 7.33398 2.66671 7.63246 2.66671 8.00065C2.65679 10.558 4.46355 12.7625 6.97308 13.2549C9.4826 13.7473 11.9884 12.3891 12.9457 10.0176C13.9029 7.6461 13.042 4.92895 10.8938 3.54135C8.74562 2.15374 5.91482 2.4863 4.14671 4.33398H5.74671C6.1149 4.33398 6.41337 4.63246 6.41337 5.00065C6.41337 5.36884 6.1149 5.66732 5.74671 5.66732H2.74671C2.37852 5.66732 2.08004 5.36884 2.08004 5.00065V2.00065C2.08004 1.63246 2.37852 1.33398 2.74671 1.33398C3.1149 1.33398 3.41337 1.63246 3.41337 2.00065V3.18065ZM7.33337 6.00065C7.33337 5.63246 7.63185 5.33398 8.00004 5.33398C8.36823 5.33398 8.66671 5.63246 8.66671 6.00065V7.33398H9.33337C9.70156 7.33398 10 7.63246 10 8.00065C10 8.36884 9.70156 8.66732 9.33337 8.66732H8.00004C7.63185 8.66732 7.33337 8.36884 7.33337 8.00065V6.00065Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.162b5888f9b3e8056a34ef8dc7182acd.svg";
export { ForwardRef as ReactComponent };